@if (showMe) {
  <div>
    <mat-divider class="sidenavDivider mat-divider mat-divider-horizontal ng-star-inserted" role="separator"
    aria-orientation="horizontal"></mat-divider>
    <mat-nav-list>
      @if (localConfig.isDataLoading) {
        <div>
          @for (number of [0,1,2,3,5,5,6,7,8,9]; track dataService.getTrackByIndex(colIndex, number); let colIndex = $index) {
            <fg-skeleton-loader loaderType="fg-side-nav"
              >
            </fg-skeleton-loader>
          }
        </div>
      }
      @if (!localConfig.isDataLoading) {
        <mat-accordion class="navigation">
          <div class="app-tile">
            <div class="app-logo">
              <i class="{{currentApp.icon}} app-icon" aria-hidden="true"></i>
            </div>
            <div class="app-details">
              <div class="app-name">{{currentApp.appTitle}}s</div>
              <div class="app-subtitle">{{currentApp.subTitle}}</div>
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="pb-1"></div>
          @for (menu of menus; track dataService.getTrackByIndex(i, menu); let i = $index) {
            <!-- If menuGroup is true, render an expansion panel -->
            @if (menu.menuGroup) {
              <mat-expansion-panel [expanded]="currentIndex === i" (opened)="setIndex(i)">
                <mat-expansion-panel-header (click)="toggleActive(menu, i)"
                  [ngClass]="findActiveMenu() && currentIndex === i ? 'sidenav-active-menu' : ''">
                  <mat-panel-title>
                    @if (menu.icon) {
                      <span class="menuIcon" [class]="menu.icon"></span>
                    }
                    @if (!menu.icon) {
                      <span class="iconName  fg-{{ menu.name | uppercase }}">
                        <span class="fa-stack fa-lg fg-list-icon-stack">
                          <i class="fa fa-circle fa-stack-2x fg-list-fl-circle" aria-hidden="true"></i>
                          <i class="fa fa-stack-1x fa-inverse " aria-hidden="true">
                          {{extractFirstLetters(menu.name)}}</i>
                        </span>
                      </span>
                    }
                    <span class="menuName">{{ menu.name || 'Menu' }}</span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @if (menu.children && menu.children.length > 0) {
                  <mat-list>
                    @for (submenu of menu.children; track dataService.getTrackByIndex(colIndex, submenu); let colIndex = $index) {
                      <mat-list-item class="menuItem"
                        (click)="toggleActive(submenu, i)"
                        [ngClass]="currentIndex === i && currentSubMenuIndex === colIndex ? 'sidenav-active-submenu' : ''">
                        @if (submenu.icon) {
                          <span [class]="submenu.icon + ' submenuIcon'"></span>
                        }
                        <span class="submenuName">{{ submenu.name }}</span>
                      </mat-list-item>
                    }
                  </mat-list>
                }
              </mat-expansion-panel>
            }
            <!-- If menuGroup is false, render a standalone list item -->
            @if (!menu.menuGroup) {
              <mat-list-item (click)="toggleActive(menu, i)"
                [ngClass]="currentIndex === i ? 'sidenav-active-submenu' : ''">
                <span>
                  @if (menu.icon) {
                    <span [class]="menu.icon + ' menuIcon'"></span>
                  }
                  @if (!menu.icon) {
                    <span class="iconName fg-{{ menu.name | uppercase }}">
                      <span class="fa-stack fa-lg fg-list-icon-stack">
                        <i class="fa fa-circle fa-stack-2x fg-list-fl-circle" aria-hidden="true"></i>
                        <i class="fa fa-stack-1x fa-inverse " aria-hidden="true">
                        {{extractFirstLetters(menu.name)}}</i>
                      </span>
                    </span>
                  }
                  <span class="menuName">{{ menu.name }}</span>
                </span>
              </mat-list-item>
            }
          }
        </mat-accordion>
      }
      @if (appConfig?.htmlContent) {
        <div class="htmlContent">
          <p [innerHtml]="appConfig?.htmlContent | safe:'html'"></p>
        </div>
      }
    </mat-nav-list>
  </div>
}